export const BASE_CLASS = 'mt-BannerBasic'
